import script from "./[assignmentId].vue?vue&type=script&setup=true&lang=ts"
export * from "./[assignmentId].vue?vue&type=script&setup=true&lang=ts"

import "~/pages/_workflow.css?vue&type=style&index=0&id=207b03c8&scoped=true&lang=css&external"
import "./[assignmentId].vue?vue&type=style&index=1&id=207b03c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-207b03c8"]])

export default __exports__